module.exports = "/_next/static/images/HeroImage@2x-feaefe64fc506ecfe4705c999090b58c.png";